(ns dashboard.components.paginated-list.config)

(def component-id :component/paginated-list)
